<template>
  <div data-app>
    <link v-if="clientId==='digiteka'" rel="stylesheet" href="/static/css/digiteka.css" type="text/css" media="all">
    <v-toolbar flat id="top-bar" class="container">
      <v-toolbar-title class="logo-wrap">
        <img v-if="$store.state.consumerLogo" v-bind:src="$store.state.consumerLogo" alt="logo">
        <img v-else src="./assets/img/logo.png" alt="logo" />
      </v-toolbar-title>
<!--      <span class="consumer-name" v-if="$store.state.consumerName">{{ $store.state.consumerName }}</span>-->
      <v-spacer></v-spacer>
      <v-toolbar-items class="top-menu">
        <router-link :to="{path: '/videos/new', exact: true}">{{ $t('menu.videos') }}</router-link>
        <router-link v-if="$store.state.consumerGroup == 'ebra'" :to="{path: '/images/new', exact: true}">{{ $t('menu.images') }}</router-link>
        <template v-if="$store.state.is_manager">
<!--          <router-link :to="{path: '/marker', exact: true}">-->
<!--            <span v-if="isLmrConsumer">{{ $t('menu.missions') }}</span>-->
<!--            <span v-else>{{ $t('marker.events')}}</span>-->
<!--          </router-link>-->
          <router-link :to="{path: '/user', exact: true}">{{ $t('menu.users')}}</router-link>
          <router-link :to="{path: '/settings', exact: true}">{{ $t('menu.settings')}}</router-link>
        </template>
        <template v-if="$store.state.authenticated">
          <a @click.stop.prevent="logout" href="">{{ $t('logout') }}</a>
        </template>
        <template v-else>
         <a @click.stop.prevent="logout" href="">{{ $t('login') }}</a>
        </template>
        <div class="dropdown locale-menu">
          <a class="clickable dropdown-toggle" @click="dropdownToggle = !dropdownToggle">{{currentLocale}} <span class="caret"></span></a>
          <ul :class="{'show': dropdownToggle}" class="dropdown-menu">
            <li><a href="" @click.stop.prevent="updateLocale('en')">en</a></li>
            <li><a href="" @click.stop.prevent="updateLocale('fr')">fr</a></li>
          </ul>
        </div>
      </v-toolbar-items>
    </v-toolbar>

    <div class="container">
      <service-message></service-message>
      <transition name="fade" mode="out-in">
        <router-view></router-view>
      </transition>
      <error-display class="error-display"></error-display>
      <update-prompt v-if="updateAvailable"></update-prompt>
      <modal-record-player></modal-record-player>
      <snack-bar></snack-bar>
    </div>
  </div>
</template>

<script>
// Root app component
import auth from './services/auth'
import dates from './services/dates'
import http from './services/http'
import updateManager from './services/update'
import ErrorDisplay from './components/Error.vue'
import UpdatePrompt from './components/UpdatePrompt.vue'
import ModalRecordPlayer from './components/marker/record/ModalRecordPlayer.vue'
import store from './store'
import SnackBar from './components/generic/SnackBar.vue'
import { mapGetters } from 'vuex'
import ServiceMessage from './components/generic/ServiceMessage'

export default {
  store,
  components: {
    ErrorDisplay,
    ModalRecordPlayer,
    UpdatePrompt,
    SnackBar,
    ServiceMessage,
  },
  data: function () {
    return {
      dropdownToggle: false,
      updateAvailable: false,
      clientId: ''
    }
  },
  mounted: function () {
    // hook up global events
    // check for updates on window focus
    this.checkForUpdate()
    window.addEventListener('focus', this.checkForUpdate, false)
    http.bus.$on('request-error', (error) => {
      if (error.response && error.response.status === 401) {
        this.logout()
      }
      return true
    })
    http.bus.$on('outbound-request', function (opts) {
      /* global Pace:false */
      if (opts.silent !== true) {
        Pace.restart()
      }
    })
    this.clientId = localStorage.getItem('client_id') || ''
  },
  methods: {
    logout () {
      auth.logout()
      this.$router.push('/login')
    },
    updateLocale (l) {
      this.setAppLocale(l)
      this.dropdownToggle = false
    },
    setAppLocale (l) {
      this.$i18n.locale = l
      dates.updateLocale(l)
      localStorage.setItem('preferred_locale', l)
    },
    checkForUpdate () {
      updateManager.checkForUpdate(() => {
        this.updateAvailable = true
      })
    }
  },
  computed: {
    ...mapGetters(['isLmrConsumer']),
    currentLocale () {
      return this.$i18n.locale
    }
  }
}
</script>

<style src="./assets/css/main.sass" lang="sass"></style>



// WEBPACK FOOTER //
// App.vue?67325137